<div class="clug-list-card">
  <div class="card-loader" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div class="card-header">
    <span class="card-header-count">{{totalCount}} Assignment(s)</span>
    <div class="input-group">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search job, client, contractor..." [(ngModel)]="assignmentSearch" (keyup)="searchAssignment()">
    </div>
  </div>

  <div class="table-responsive">
    <table matSort (matSortChange)="sortData($event)" class="table">
      <thead>
        <tr>
          <th mat-sort-header="job" scope="col">Job</th>
          <th mat-sort-header="candidate" scope="col">Candidate</th>
          <th mat-sort-header="client" scope="col">Client</th>
          <th mat-sort-header="start_date" scope="col">Start Date</th>
          <th mat-sort-header="end_date" scope="col">End Date</th>
          <th mat-sort-header="created_at" scope="col">Created At</th>
          <th mat-sort-header="action" scope="col" class="actions-col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr class="assignmentsRow dataColumn" *ngFor="let jobAssignment of allJobAssignments">
          <td *ngIf="user?.role_uuid === ROLES?.CANDIDATE">
            <div class="cell-with-icon">
              <span class="cell-icon"><i class="bi bi-briefcase"></i></span>
              <span class="cell-text">{{jobAssignment.job}}</span>
              <i class="bi bi-plus-circle-fill text-primary ms-2" matTooltip="Create Timesheet" (click)="createTimesheet(jobAssignment)"></i>
            </div>
          </td>
          <td *ngIf="user?.role_uuid !== ROLES?.CANDIDATE">
            <div class="cell-with-icon">
              <span class="cell-icon"><i class="bi bi-briefcase"></i></span>
              <span class="cell-text">{{jobAssignment.job}}</span>
            </div>
          </td>
          <td>{{jobAssignment.candidate}}</td>
          <td>{{jobAssignment.client}}</td>
          <td>{{dataSharedService.tranformDate(jobAssignment.start_date)}}</td>
          <td>{{dataSharedService.tranformDate(jobAssignment.end_date)}}</td>
          <td>{{dataSharedService.tranformDate(jobAssignment.created_at)}}</td>
          <td *ngIf="user?.role_uuid !== ROLES?.CANDIDATE" class="td-actions">
            <div class="row-actions">
              <button type="button" *ngIf="user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.CLIENT" class="icon-btn-sm info" matTooltip="Edit" (click)="onEdit(jobAssignment)">
                <i class="bi bi-pencil"></i>
              </button>
              <button type="button" *ngIf="user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.CLIENT" class="icon-btn-sm reject" matTooltip="Deactivate assignment" [matTooltipPosition]="'left'" (click)="inactivateAssignment(jobAssignment.uuid)">
                <i class="bi bi-lock"></i>
              </button>
              <button type="button" class="icon-btn-sm" matTooltip="Send Mail" [matTooltipPosition]="'left'" (click)="openSendMessagePopUp(jobAssignment.candidate_uuid)">
                <i class="bi bi-envelope"></i>
              </button>
            </div>
          </td>
          <td *ngIf="user?.role_uuid == ROLES?.CANDIDATE" class="td-actions">
            <div class="row-actions">
              <button type="button" *ngIf="jobAssignment.is_contract_submitted === false && jobAssignment.is_contract_uploaded === true" class="icon-btn-sm warning" matTooltip="Submit Contract" [matTooltipPosition]="'left'" (click)="viewOnBoardingForm(jobAssignment, true)">
                <i class="bi bi-c-square"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-pagination" *ngIf="totalCount">
    <span class="pagination-summary">
      Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} assignments
    </span>
    <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
  </div>
</div>
